<template>
  <div class="home">
    <Head/>
    <Deploy/>
  </div>
</template>

<script>
import Head from './Head'
import Deploy from './Deploy'

export default {
  name: 'home',
  components: {
    Head,
    Deploy
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
}
</style>
